<template>
  <div class="c-msg-box elevation-2" :class="isJson ? 'c-json' : ''" :style="`max-width: ${maxWidth}px`">
    <template v-if="isJson">
      <talk-msg-event v-if="json.t == 'E'" :tid="tid" :data="json" :maxWidth="maxWidth" />
      <talk-msg-album v-else-if="json.t == 'A'" :tid="tid" :data="json" :maxWidth="maxWidth" />
      <talk-msg-post v-else-if="json.t == 'P'" :tid="tid" :data="json" :maxWidth="maxWidth" />
      <talk-msg-call v-else-if="json.t == 'CALL'" :tid="tid" :talkMsg="talkMsg" :data="json" :maxWidth="maxWidth" />
      <div v-else>UNSUPPORTED<{{ JSON.stringify(talkMsg.msg) }}</div>
    </template>
    <template v-else>
      <div v-html="fmtMsg(talkMsg.msg)" />
    </template>
  </div>
</template>

<script>
import TalkMsgPost from './TalkMsgPost.vue';
import TalkMsgAlbum from './TalkMsgAlbum.vue';
import TalkMsgEvent from './TalkMsgEvent.vue';
import TalkMsgCall from './TalkMsgCall.vue';

export default {
  components: {
    'talk-msg-post': TalkMsgPost,
    'talk-msg-album': TalkMsgAlbum,
    'talk-msg-event': TalkMsgEvent,
    'talk-msg-call': TalkMsgCall,
  },
  props: {
    tid: { type: Number, required: true },
    talkMsg: { type: Object, required: true },
    maxWidth: { type: Number, required: true },
  },
  data() {
    return {};
  },
  mounted() {},
  watch: {},
  computed: {
    isJson() {
      return this.talkMsg.msg.startsWith('{');
    },
    msg() {
      return this.talkMsg.msg.startsWith('\\') ? this.talkMsg.msg.substring(1) : this.talkMsg.msg;
    },
    json() {
      return JSON.parse(this.talkMsg.msg);
    },
  },
  methods: {
    fmtMsg(msg) {
      return formatExplain(msg);
    },
  },
};
</script>
